export enum PackageWeightUnitValue {
    KG = '0',
    LB = '1'
}
